import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './CardLabel.module.scss'
const cx = cn.bind(s)

interface ICardLabelProps {
	label: string
	className?: string
}

const CardLabel: FC<ICardLabelProps> = ({label, className}) => {
	return <div className={cx('label', className)}>{label}</div>
}

CardLabel.displayName = 'CardLabel'

export default CardLabel
